module.exports = __webpack_public_path__ + "img/no-simulations-found.d45ab096.svg";